<template>
    <div class="container-fluid footer_instagram bg-black">
        <div class="row py-3">
            <div class="col-12 insta_cta text-center">
                <a href="https://www.instagram.com/cincyexperience/" target="_blank">STAY IN THE KNOW - FOLLOW US ON INSTAGRAM</a>
            </div>
        </div>
        <div class="row">
            <div class="insta_scroll w-100">
                <div class="glide__track" data-glide-el="track">
                    <ul class="glide__slides d-flex flex-row justify-content-start">
                        <li class="glide__slide" v-for="(item, index) of paneldata.items" :key="'image_' + item.title + '_' + index">
                            <a :href="item.link" target="_blank" :title="item.image.alt + '- Instagram Post'">
                                {{item.title}}
                                <img :src="item.image.url" :alt="item.image.alt" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
@import "../../../node_modules/bootstrap/scss/_functions.scss";
@import "../../../node_modules/bootstrap/scss/mixins.scss";
@import "../../scss/config/bootstrap.scss";

.footer_instagram {
    .insta_cta {
        a {
            &:hover {
                color: $tequila;
            }
        }
    }
    .insta_scroll {
        img {
            max-height: 200px;
        }
    }
}

ul.glide__slides {
    padding: 0;
    margin: 0;
    list-style-type: none;
    li.glide__slide {
        padding: 0;
        margin: 0;
        a {
            position: relative;
            display: block;
            &:before {
                content: "";
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background: rgba(0, 0, 0, 0);
            }
            &:after {
                content: "";
                position: absolute;
                top: calc(50% - 20px);
                left: calc(50% - 20px);
                opacity: 0;
                display: block;
                width: 40px;
                height: 40px;
                border: 2px solid $white;
                background: url('/assets/images/svg/arrow-left-white.svg') no-repeat;
                background-position: center center;
            }
            &:hover {
                &:before {
                    background: rgba(0, 0, 0, 0.5);
                }
                &:after {
                    opacity: 1;
                }
            }
        }
    }
}
</style>
<script>
import Glide from "@glidejs/glide";
export default {
  props: {
    paneldata: {
        type: Array|Object
    }
  },
  data() {
    return {};
  },
  computed: {
  },
  methods: {
    
    mountSlider() {
        const instaSliderElement = this.$el.querySelector('.insta_scroll');
        // console.log(instaSliderElement);

        const instaSlider = new Glide(instaSliderElement, {
            type: 'carousel',
            perView: 10,
            startAt: 0,
            autoplay: 4000,
            hoverpause: true,
            gap: 0
        }).mount();
        

    },
  },
  created() {},
  mounted() {
      
      this.mountSlider();
  }
};
</script>
